// extracted by mini-css-extract-plugin
export default {"narratives":"Profile_narratives__rNxFr","profile":"Profile_profile__eyNpt","profile-narratives":"Profile_profile-narratives__uFGzz","profile-nav":"Profile_profile-nav__TppTl"};